// extracted by mini-css-extract-plugin
export default {"edit_wrapper":"EditTicketModal_edit_wrapper__mLoR0","br":"EditTicketModal_br__5PcBO"};